module.exports = __webpack_public_path__ + "static/media/film-production-grid-2.94afab72.jpg";